import Vue from 'vue';
import paymentService from './../../../services/payment';
import mixin from "../../../mixins/mixin";

export default {
  data() {
    return {
        permalink: this.$route.params.permalink,
        stripeToken: null,
        stripeEmail: null,
        error: null,
        success: false,
        loading: false,
        pageTitle: 'Payment - THERENTALNAME - SuperHote.com',
        payment: {},
        errorDataNotFound: false,
        paymentDisabled: false,
        checkoutUrl: process.env.API_LOCATION,
        stripe: null,
        elements: null,
        card: null,
        cardCvc: null,
        cardNumber: null,
        cardExpiry: null,
        paymentIntent: null,
        showSecureIframe: false,
        userCurrency: '€',
        rentalInfo: {}
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading: require('components/loading/loading.vue'),
  },
  mixins: [mixin],
  async mounted() {

    let vm = this;
    vm.loading = true;

    if (localStorage.getItem('lang')) {
      Vue.config.lang = localStorage.getItem('lang');
    } else {
      let userLang = navigator.language || navigator.userLanguage;
      if(userLang == "fr"){
          vm.changeLang("fr");
      }else{
          vm.changeLang("en");
      }
    }
      await vm.fetch_payment(vm.$route.params.permalink);
      const elementStyle = {
        base: {
          color: '#878787',
          lineHeight: '37px',
          fontSize: '18px',
          '::placeholder': {
            color: '#878787'
          }
        }
      };
      if (vm.elements) {
        vm.cardNumber = vm.elements.create('cardNumber', {
          style: elementStyle,
          placeholder: 'Card number',
        });
        vm.cardNumber.mount('#card-number');
        vm.cardExpiry = vm.elements.create('cardExpiry', {
          style: elementStyle,
          placeholder: 'MM/AA',
        });
        vm.cardExpiry.mount('#card-expiry');
        vm.cardCvc = vm.elements.create('cardCvc', {
          style: elementStyle,
          placeholder: 'CVC',
        });
        vm.cardCvc.mount('#card-cvc');
      }
      this.handle3DCListener();
  },
  watch: {
      pageTitle: function (val, old) {
          document.title = val
      }
  },
  methods: {
      async fetch_payment(permalink){
          let vm = this;
          await paymentService.getByPermalink(vm, permalink);
      },
      async submitCheckout(){
          let vm = this;
          vm.loading = false;
          vm.paymentDisabled = true;
        // Request token from Stripe
        vm.stripe.createToken(vm.cardNumber).then(vm.stripeResponseHandler);
      },
      async stripeResponseHandler(response){
        if (response.error) { // Problem!
            this.getErrorMessage(response.error);
            toastr.error(text);
            this.paymentDisabled = false;
        } else {
          this.stripeToken = response.token.id;
            let data = {
                'stripeToken': this.stripeToken,
                'paymentId': this.payment.id,
                'stripeEmail': this.stripeEmail
            };
          this.paymentDisabled = true;
          await paymentService.checkout(data, this);
        }
      },
      on3DSComplete() {
        const vm = this;
        $("#secure-iframe").css("display", "none");
        vm.loading = true;
        if(vm.stripe && vm.paymentIntent && vm.paymentIntent.client_secret) {
          vm.stripe.retrievePaymentIntent(vm.paymentIntent.client_secret)
            .then(function(result) {
              if (result.paymentIntent && result.paymentIntent.last_payment_error && result.paymentIntent.last_payment_error.code
                && result.paymentIntent.last_payment_error.code === 'payment_intent_authentication_failure') {
                toastr.error(this.$t('payments.error.card_declined'));
                vm.showSecureIframe = false;
                vm.loading = false;
                // PaymentIntent client secret was invalid
              } else {
                if (result.paymentIntent.status === 'succeeded' || result.paymentIntent.status === 'requires_capture') {
                  vm.showSecureIframe = false;
                  let data  = {
                    'paymentIntent' : result.paymentIntent,
                    'paymentId' : vm.payment.id,
                    'stripeEmail': vm.stripeEmail
                  };
                  paymentService.checkout(data, vm);
                } else if (result.paymentIntent.status === 'requires_payment_method') {
                  toastr.error(this.$t('payments.error.card_declined'));
                  vm.showSecureIframe = false;
                  vm.loading = false;
                  // Authentication failed, prompt the customer to enter another payment method
                }
              }
            })
        }
    },
      handle3DCListener() {
        const ifr = document.querySelector('iframe');
        const otherWindow = ifr.contentWindow;
        ifr.addEventListener('load', () => {
          const ifrElementId = ifr.contentWindow.frameElement.id;
          if (ifrElementId === 'secure-iframe') {
            otherWindow.postMessage('3DS-authentication-complete', '*');
            otherWindow.addEventListener('message', (ev) => {
              if (ev.data === '3DS-authentication-complete') {
                this.on3DSComplete();
              }
            }, false);
          }
        }, false);
      },
  }
};



// WEBPACK FOOTER //
// ./src/app/pages/payments/permalink/permalink.js